// React
import { ReactElement, useState } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Features
import { Information } from './Information';
import { ModalOrganizerChangePassword } from './modals/ModalOrganizerChangePassword';
// Contexts
import { useDashboard } from '@utmb/contexts/DashboardContext';
import { useUser } from '@utmb/contexts/AuthContext';
// Styles
import styles from './basic-information.module.scss';
import { BlockDashboardWrapper } from '../my-utmb/BlockDashboardWrapper';
import { Font } from '@utmb/design-system/text/font';

export const OrganizerAccountSettings = (): ReactElement | null => {
    const { dashboardOrganizer } = useDashboard();
    const { t } = useTranslation();
    const { me } = useUser();

    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);

    if (!dashboardOrganizer) {
        return null;
    }

    return (
        <div className={styles.root}>
            <BlockDashboardWrapper
                label={<Font.FuturaHeavy as="span">{t('myutmb:myUtmb.myInformation.accountSettings.title')}</Font.FuturaHeavy>}
                onChange={() => setIsChangePasswordModalOpen(true)}
                standalone
            >
                <div className={styles.information_container_orga}>
                    <div className={`${styles.information_row_orga} row`}>
                        <Information classNameValue={styles.wide} label={t('myutmb:myUtmb.myInformation.accountSettings.login')}>
                            <span className={styles.underlined}>{me!.email}</span>
                        </Information>
                        <Information classNameValue={styles.wide} label={t('myutmb:myUtmb.myInformation.accountSettings.password')}>
                            <span className={styles.underlined}>***********</span>
                        </Information>
                    </div>
                </div>
            </BlockDashboardWrapper>

            <ModalOrganizerChangePassword isOpen={isChangePasswordModalOpen} close={setIsChangePasswordModalOpen} />
        </div>
    );
};
